import axios from "functions/axios";

export const ListUsersAPI = ({ page = 1, page_size = 15, search = "" } = {}) =>
  axios
    .get("user/users/list/", {
      params: { page, page_size, search },
    })
    .then((res) => res.data);

export const ListAllUsersAPI = ({ search = "" } = {}) =>
  axios
    .get("user/users/all/", {
      params: { search },
    })
    .then((res) => res.data);

export const ConvertUserToAgentAccountAPI = (userID) =>
  axios.post(`user/user/convert_to_agent/${userID}/`).then((res) => res.data);
